import styled from 'styled-components'

export const MapContainer = styled.div`
  height: calc(100vh - 16px - 57px - 100px);
  width: 100%;
`
